import createReactComponent from '../createReactComponent';
export default createReactComponent('danger-circle', 'DangerCircle', [["path",{"d":"M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0m-9-4.373v5.5m0 3.246v-.5","key":"svg-0"}]]);